// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4e5eb704","455":"14b3a017","977":"d39097c1"}[chunkId] + ".chunk.js";
};